parasails.registerPage('quapi-mobile', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    eventID: '',
    overallEventID: '',
    deviceidentifier: '',
    eventType: '',
    partType: '',
    eventData: {},
    eventIsLive: false,
    partIsLive: false,
    showResults: false,
    fireworksEnabled: true,
    alwaysShowFireworks: false,
    showFirework: false,
    partIndex: 0,
    questionIndex: 0,
    pleaseWait: true,
    currentPartData: {},
    currentVoteData: {},
    clickSignalTime: 0,
    isChargeMode: true,
    currentIconImage: 'icon_hart_pink_256.png',
    currentIconName: 'LikeHeartPink',
    backgroundStyle: 'background-image: url("../images/Visibby汎用BG.png");',
    eventLogo: 'images/caramel-logo.png',
    serviceIconImage: 'images/Visibby_Logo_H_S.png',
    serviceColorStyle: 'color: #ffffff;',
    additionalstyle: '-webkit-background-size: cover !important; -moz-background-size: cover !important; -o-background-size: cover !important; background-size: cover !important; background-repeat: no-repeat !important; display: flex !important; align-items: center !important; align-content: center !important; justify-content: center !important; flex-wrap: nowrap !important; background-position: center !important;',
    idleTexts: {
      waiting: "Please wait",
      noActiveVote: "Please wait",
      partNotLive: "Please wait",
      eventNotLive: "Please wait",
      waitingColor: "#000000",
      noActiveVoteColor: "#000000",
      partNotLiveColor: "#000000",
      eventNotLiveColor: "#000000"
    },
    showVoteConfirmation: false,
    selectedVoteText: '',
    selectedVoteIndex: -1,
    freeSwitch: false,
    keyhackval: 0,
    isRefreshingData: false,
    showLikeButton: true,
    likeButtonKey: 0,
    whiteLabel: false
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },

  computed: {
    questionBoderStyle: function() {
        return {
            backgroundColor: this.currentVoteData.bgcolor || '#FFFFFF', // Use bgcolor for fill, default white
            borderColor: this.currentVoteData.color || '#000000' // Use color for frame, default black
        };
    },
    questionBoxStyle: function() {
        // Based on your last working configuration:
        // 'color' from DB is for the FILL/background color
        // 'bgcolor' from DB is for the FRAME/border color
        let effectiveFrameColor = this.currentVoteData.color || '#000000'; // Default frame color
        return {
            backgroundColor: this.currentVoteData.bgcolor || '#FFFFFF',   // Fill color
            borderColor: effectiveFrameColor,    // Border color
            color: this.currentVoteData.textcolor || effectiveFrameColor, // Text color
            borderStyle: 'solid', // Ensure a solid border style
            borderWidth: '3px'    // Adjust this value for desired border thickness (e.g., '5px', '10px')
        };
    },
  },
  mounted: async function() {
    //…
    document.addEventListener('visibilitychange', this.visChanged, false);
    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    this.eventID = this.eventData.id;
    this.setBGStyle(false);
    this.setLogo();

    if(this.eventData.eventType.length > 0) {
      this.eventType = this.eventData.eventType[0].name;
      this.deviceidentifier = this.eventData.deviceidentifier;
      this.eventIsLive = this.eventData.isLive;
    }
    if(this.eventData.parts.length > 0) {
      if(this.eventData.focusPartID != null) {
        //This event has a focus part, so we need to find it and set the partIndex to that...
        for(var fpi = 0; fpi < this.eventData.parts.length; fpi++) {
          if(this.eventData.parts[fpi].id === this.eventData.focusPartID) {
            this.partIndex = fpi;
            break;
          }
        }
      } else {
        for(var pi = 0; pi < this.eventData.parts.length; pi++) {
          if(this.eventData.parts[pi].isLive) {
            this.partIndex = pi;
            if(this.eventData.parts[pi].questions) {
              //Loop through all questions and find the currently live one...
              for(var qi = 0; qi < this.eventData.parts[pi].questions.length; qi++) {
                if(this.eventData.parts[pi].questions[qi].isLive) {
                  this.questionIndex = pi;
                }
              }
            }
            break;
          }
        }
      }


      if(!this.partIndex) {this.partIndex = 0;}

      this.currentPartData = this.eventData.parts[this.partIndex];
      this.partIsLive = this.currentPartData.isLive;
      this.currentVoteData.partindex = this.partIndex;
      this.currentVoteData.questionIndex = this.questionIndex;
      this.freeSwitch = this.currentPartData.freeSwitch;
      this.clickSignalTime = (this.currentPartData.clickSignalTime) ? this.currentPartData.clickSignalTime : 0;
      if(this.currentPartData.hasOwnProperty('eventPartOptions')) {
        if(this.currentPartData.eventPartOptions.hasOwnProperty('whiteLabel')) {
          this.whiteLabel = this.currentPartData.eventPartOptions.whiteLabel;
        }
        if(this.currentPartData.eventPartOptions.hasOwnProperty('idleTexts')) {
          this.idleTexts = this.currentPartData.eventPartOptions.idleTexts;
        }

        this.isChargeMode = (this.currentPartData.eventPartOptions.hasOwnProperty('isChargeMode')) ? this.currentPartData.eventPartOptions.isChargeMode : true;
        if(this.currentPartData.eventPartOptions.hasOwnProperty('useDarkService')) {
          if(this.currentPartData.eventPartOptions.useDarkService) {
            this.serviceIconImage = 'images/Visibby_Logo_H_S_BK.png';
            this.serviceColorStyle = "color: #000000;";
          } else {
            this.serviceIconImage = 'images/Visibby_Logo_H_S.png'
            this.serviceColorStyle = "color: #ffffff;";
          }
        }
      }
      //--------------------------------------------------------------------------------
      this.partType = this.currentPartData.partType.toLowerCase();
      switch(this.partType) {
        case 'vote':
        case 'qa':
          console.log("2 - partIsLive = " + this.partIsLive);
          if(this.currentPartData.questions.length > 0) {
            this.setCurrentVote(this.partIndex, this.questionIndex);
            this.setBGStyle(true);
          } else {
            console.log('No Question/Vote data found in part.');
          }
          break;
        case 'like':
          this.selectIcon(this.currentPartData.icons[0].image, this.currentPartData.icons[0].name);
          this.fireworkActivated();
          break;
        case 'qr':
          this.partIsLive = false;
          this.pleaseWait = true;
          break;
        case 'chirp':
          //If this is a chirp type, and the page is set to allow users to free switch, then this page needs to show the please wait message...
          this.partIsLive = false;
          this.pleaseWait = true;
          break;
        default:
          this.partType = this.eventType;
          //If this is a chirp type, and the page is set to allow users to free switch, then this page needs to show the please wait message...
          this.partIsLive = false;
          this.pleaseWait = true;
      }
    }
    else {
      console.log('event has no parts data');
    }

    //Sockets

    // console.log('Setting listerner for id : ' + this.eventData.id);
    io.socket.on(this.eventData.id, (params) => {
      console.log("Connected!");
      this.showResults = false;
      switch(params.eventType) {
        case 'startevent':
          this.setBGStyle(false);
          this.partIsLive = false;
          this.eventIsLive = true;
          break;
        case 'endevent':
          this.setBGStyle(false);
          this.partIsLive = false;
          this.eventIsLive = false;
          break;
        case 'startpart':
          console.log("Received START PART");
          this.partIndex = params.partindex;
          this.currentPartData = this.eventData.parts[this.partIndex];
          if(!this.questionIndex) {this.questionIndex = this.partIndex;}
          this.currentVoteData.partindex = this.questionIndex;
          if(this.freeSwitch === true) {
            //Free switch means the user is able to freely switch between stamp and chirp.
            console.log("FREE SWITCH IS TRUE - " + this.freeSwitch);
          } else if(this.currentPartData.partType === 'tweet' || this.currentPartData.partType === 'chirp') {
            console.log("Set part to live - chirp");
            //Redirect to chirp page...
            this.goto('/chirp?eventID=' + this.overallEventID);
          } else if(this.currentPartData.partType === 'vote' || this.currentPartData.partType === 'qa' || this.currentPartData.partType === 'quiz') {
            console.log("Set part to live - vote");
            this.partIsLive = true;
            console.log("3 - partIsLive = " + this.partIsLive);
            this.pleaseWait = true;
          } else if(this.currentPartData.partType === 'wait') {
            console.log("Set part to live - wait");
            this.partIsLive = true;
            this.pleaseWait = true;
          } else if(this.currentPartData.partType === 'qr') {
            console.log("Set part to live - qr");
            this.partIsLive = true;
            this.pleaseWait = true;
          } else {
            console.log("Set part to live - default");
            this.partIsLive = true;
            this.pleaseWait = false;
          }
          this.currentPartData.isLive = this.partIsLive;

          this.clickSignalTime = (this.currentVoteData.clickSignalTime) ? this.currentVoteData.clickSignalTime : 0;
          this.setBGStyle(true);
          this.fireworkActivated();
          //--------------------------------------------------------------------------------
          this.partType = this.currentPartData.partType.toLowerCase();
          break;
        case 'endpart':
          this.setBGStyle(false);
          this.pleaseWait = true;
          this.partIsLive = false;
          break;
        case 'startvote':
        case 'rotatevote':
          console.log("Received START VOTE");
          this.partIsLive = true;
          console.log("4 - partIsLive = " + this.partIsLive);
          this.pleaseWait = false;
          this.setCurrentVote(params.partindex, params.voteid, true);
          this.currentVoteData.isLive = true;
          this.setBGStyle(true);
          break;
        case "endquestion":
          console.log("Received END QUESTION");
          this.endQuestion(params.partindex, params.voteid)
          this.setCurrentVote(params.partindex, params.voteid, true);
          this.setBGStyle(true);
          break;
        case 'endvote':
          this.partIsLive = false;
          this.setBGStyle(false);
          break;
        case 'showresults':
        case 'pleasewait':
          this.showResults = true;
          break;
        case 'dataupdated':
          location.reload();
          break;
      }
    });
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    visChanged () {
      if (document.visibilityState === 'hidden') {
        // pause animation, video, etc
      } else {
        //console.log("VISIBILITY CHANGED - " + document.visibilityState);
        location.reload();
      }
    },
    async setCurrentVote(partIndex, voteIndex, fromSocket = false) {
      console.log("SHOW VOTE CALLED");
      this.showVoteConfirmation = false;
      //Loops through all votes and deactivates them, then sets the curent vote as active...
      this.pleaseWait = false;
      this.partIsLive = true;
      this.partIndex = partIndex;
      this.questionIndex = voteIndex;
      for(var p in this.eventData.parts) {
        p.isLive = false;
      }
      this.currentPartData = this.eventData.parts[partIndex];
      this.currentPartData.isLive = true;
      //Try to get fresh data...
      if(this.isRefreshingData === false) await this._fetchNewQuestionData();

      if(fromSocket === false) {
        for(var timmy = 0; timmy < this.eventData.parts[partIndex].questions.length; timmy++)
        {
          if(this.eventData.parts[partIndex].questions[timmy].isLive === true)
          {
            this.questionIndex = timmy;
            break;
          }
        }
      }
      //this.currentPartData.questions = this.eventData.parts[this.partIndex].questions;
      this.currentVoteData = this.currentPartData.questions[this.questionIndex];
      if(this.currentVoteData === null || this.currentVoteData === undefined) {
        window.location.reload();
        return;
      }
      this.currentVoteData.voted = false;
      this.currentVoteData.votedIndex = -1;
      this.selectedVoteIndex = -1;
      this.currentVoteData.partindex = partIndex;

      this.$set(this.currentVoteData, 'questionBgColor', this.currentVoteData.bgcolor); // For the fill color
      this.$set(this.currentVoteData, 'questionFrameColor', this.currentVoteData.color); // For the frame color
      this.keyhackval = Math.floor(Math.random() * 100) + 1;

      // this.fireworkActivated();ing
    },
    endQuestion(partIndex, voteIndex)
    {
      this.eventData.parts[partIndex].questions[voteIndex].isLive == false;
      this.currentVoteData.isLive = false;
    },
    voteSelected: function(index) {
      this.currentVoteData.votedIndex = index;
      this.selectedVoteIndex = index;
      this.selectedVoteText = this.currentVoteData.votes[index].text;
    },
    voted: function() {
      this.currentVoteData.voted = true;
      this.showVoteConfirmation = true;
    },
    nextQuestion: function() {
    },
    timeUp: function() {
      return;
    },
    selectIcon: function(iconImage, iconName) {
      this.currentIconImage = iconImage;
      this.currentIconName = iconName;
    },
    fireworkChance: function() {
      if(this.currentPartData.fireworksEnabled) {
        if(this.currentPartData.alwaysShowFireworks) {
          this.showFirework = true;
        } else {
          var generatedNumber = Math.floor(Math.random() * 10000);
          if(generatedNumber <= 50) { this.showFirework = true;}
        }
      } else {
        this.showFirework = false;
      }
    },
    fireworkActivated: function() {
      if(this.currentPartData.alwaysShowFireworks) {
        this.showFirework = true;
      } else {
        this.showFirework = false;
      }
    },
    setBGStyle(isPart) {
      var bgImage = '../images/Visibby汎用BG.png';
      var bgIsColor = false;
      // var additionalstyle = '-webkit-background-size: cover !important; -moz-background-size: cover !important; -o-background-size: cover !important; background-size: cover !important; background-repeat: no-repeat !important; background-color: #000000 !important; display: flex !important; align-items: center !important; align-content: center !important; justify-content: center !important; flex-wrap: nowrap !important; background-position: center !important;';
      if(isPart) {
        //before checking the part bg, check the if this is a vote and has a bg set for each question...
        if(this.currentPartData) {
          if((this.currentPartData.partType === 'vote' || this.currentPartData.partType === 'qa' || this.currentPartData.partType === 'quiz')) {
            console.log('BG Mode is ' + this.currentPartData.questions[this.questionIndex].bgMode);
            if(this.currentPartData.questions[this.questionIndex].bgMode === 'COLOR') {
              bgImage = this.currentPartData.questions[this.questionIndex].bgcolor; //Reusing the bgImage variable for color. Lets make it less ambiguosu when there is time.
              bgIsColor = true;
            } else if(this.currentPartData.questions[this.questionIndex].bgMode === 'COLORDIF') {
              bgImage = this.currentPartData.questions[this.questionIndex].bgcolor_mobile;
              bgIsColor = true;
            } else if(this.currentPartData.eventPartOptions && this.currentPartData.eventPartOptions.bgMode === 'defer') {
              bgImage = this.currentPartData.BGImage;
            } else if(this.currentPartData.questions[this.questionIndex].bgimage && this.currentPartData.questions[this.questionIndex].bgimage !== '') {
              bgImage = this.currentPartData.questions[this.questionIndex].bgimage;
            }
          } else if(this.currentPartData && this.currentPartData.BGImage && this.currentPartData.BGImage !== '') {
            bgImage = this.currentPartData.BGImage;
          } else {
            if(this.eventData.BGImage && this.eventData.BGImage !== '') {
              bgImage = this.eventData.BGImage;
            }
          }
        } else if(this.eventData.BGImage && this.eventData.BGImage !== '') {
          bgImage = this.eventData.BGImage;
        }
      } else {
        if(this.eventData.BGImage && this.eventData.BGImage !== '') {
          bgIsColor = this.eventData.BGImage.startsWith('#') === true;
          bgImage = this.eventData.BGImage;
        }
      }
      if(bgIsColor === true) {
        console.log('bgImage = ' + bgImage);
        this.backgroundStyle = this.additionalstyle + ' background-color: ' + bgImage.toLowerCase() + ' !important;';
      } else {
        this.backgroundStyle = 'background-image: url(\'' + bgImage + '\') !important; ' + this.additionalstyle;
      }
    },
    _fetchNewQuestionData: async function() {
      this.isRefreshingData = true;
      try {
        const response = await fetch(`getquizdataforpart?partid=${this.currentPartData.id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if(data !== null && data.length > 0) {
          this.eventData.parts[this.partIndex].questions = data;
          this.currentPartData.questions = data;
        }
        this.isRefreshingData = false;
      } catch (error) {
        console.error('Error fetching new question data:', error);
        this.isRefreshingData = false;
      }
    },
    setLogo() {
      if(this.eventData.logoImage) {
        this.eventLogo = this.eventData.logoImage;
      }
    },
    switchToChirp()
    {
      this.goto('/chirp?eventID=' + this.overallEventID);
    },
    resetLikeButton() {
      this.showLikeButton = false;
      this.$nextTick(() => {
        this.showLikeButton = true;
        this.likeButtonKey += 1;
      });
    },
    // Add the hexToRgba function to your main Vue instance methods if it's not already there
    hexToRgba: function(color, alpha) {
      if (!color || typeof color !== 'string') {
        return `rgba(0, 0, 0, ${alpha || 0})`;
      }

      let r, g, b;
      if (color.startsWith('#')) {
        const sanitizedHex = color.slice(1);
        let bigint;
        try {
          bigint = parseInt(sanitizedHex, 16);
        } catch (e) {
          console.warn(`Error parsing hex color: ${color}. Returning original color.`);
          return color;
        }

        if (sanitizedHex.length === 3) {
          r = ((bigint >> 8) & 0xF) * 17;
          g = ((bigint >> 4) & 0xF) * 17;
          b = (bigint & 0xF) * 17;
        } else if (sanitizedHex.length === 6) {
          r = (bigint >> 16) & 255;
          g = (bigint >> 8) & 255;
          b = bigint & 255;
        } else {
          console.warn(`Invalid hex color format: ${color}. Returning original color.`);
          return color;
        }
      } else if (color.startsWith('rgb(') || color.startsWith('rgba(')) {
        const parts = color.match(/\d+(\.\d+)?/g);
        if (parts && parts.length >= 3) {
          r = parseInt(parts[0]);
          g = parseInt(parts[1]);
          b = parseInt(parts[2]);
          return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        } else {
          console.warn(`Invalid rgb/rgba color format: ${color}. Returning original color.`);
          return color;
        }
      } else {
        console.warn(`Unsupported color format for opacity conversion: ${color}. Returning original color.`);
        return color;
      }

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  }
});